<script>
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  meetingListMethod,
  userListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'
import moment from 'moment'
export default {
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      title: '',
      description: '',
      date: '',
      startTime: '',
      endTime: '',
      teacherId: '',
      meetingError: null,
      isMeetingError: false,
      isLoading: false,
      show: false,
      platformId: 0,
      meetingSuccess: '',
      isMeetingSuccess: false,
      timeError: false,
      teacherList: [],
      classlist: [],
      collegeId: '',
      collegeClass: [],
      departmentId: [],
      departmentlist: [],
      classEmptyError: false,
    }
  },
  computed: {
    ...authComputed,
    ...departmentComputed,
  },
  mounted() {
    if (this.role === 'college') {
      this.getDepartments()
    }
    if (this.role === 'teacher') {
      this.departmentId = this.profileData.department
      this.teacherClassList = this.profileData.collegeClass
    }
    this.getTeachers()
    this.collegeId = this.profileData.college_id
    if (this.role === 'hod') {
      this.getClasses()
    }
  },
  methods: {
    ...userListMethod,
    ...meetingListMethod,
    ...departmentListMethod,
    updateMeetingData() {
      this.timeError = false
      this.isLoading = true
      if (this.collegeClass.length === 0 || this.departmentId.length === 0) {
        this.classEmptyError = true
        this.isLoading = false
      } else {
        this.classEmptyError = false
      }
      if (!this.classEmptyError) {
        const Data = {
          id: this.data._id,
          title: this.title,
          description: this.description,
          start_time: this.startTime,
          end_time: this.endTime,
          date: this.date,
          teacher_id: this.teacherId,
          collegeClass: this.collegeClass,
          department: this.departmentId,
          college_id: this.collegeId,
        }
        let datetime = moment(
          `${this.date} ${this.startTime}`,
          'YYYY-MM-DD HH:mm:ss'
        ).format()
        let datetime1 = moment(
          `${this.date} ${this.endTime}`,
          'YYYY-MM-DD HH:mm:ss'
        ).format()
        const now = new Date()
        const today = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          now.getHours(),
          now.getMinutes(),
          now.getSeconds()
        )
        const minDate = new Date(today)
        const d1 = new Date(moment(minDate).format())
        const d2 = new Date(datetime)
        const d3 = new Date(datetime1)
        if (d1 > d2 || d1 > d3) {
          this.timeError = true
          this.isLoading = false
        } else {
          this.timeError = false
        }

        if (!this.timeError) {
          this.updateMeeting({ Data })
            .then((resp) => {
              this.isLoading = false
              this.meetingSuccess = 'Class Updated Successfully'
              this.isSuccess = true
              window.location.reload()
            })
            .catch((error) => {
              this.isLoading = false
              var getError = new ErrorWrapper(error)
              this.meetingError = getError.message
              this.isMeetingError = true
            })
        }
      }
    },

    getData() {
      this.title = this.data.title
      this.description = this.data.description
      this.date = this.data.date
      this.startTime = this.data.start_time
      this.endTime = this.data.end_time
      this.teacherId = this.data.teacher_id
      let i = 0
      for (i = 0; i < this.data.department.length; i++) {
        this.departmentId.push(this.data.department[i])
      }
      this.getClasses()
      for (i = 0; i < this.data.collegeClass.length; i++) {
        this.collegeClass.push(this.data.collegeClass[i])
      }
    },

    resetModal() {
      this.timeError = false
      this.isMeetingError = false
      this.title = this.data.title
      this.description = this.data.description
      this.date = this.data.date
      this.startTime = this.data.start_time
      this.endTime = this.data.end_time
      this.teacherId = this.data.teacher_id
      this.collegeClass = []
      this.departmentId = []
      this.classEmptyError = false
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.title.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.description.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    getMinDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate())
      return minDate
    },
    getClasses() {
      this.collegeClass = []
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (
                this.departmentId[i] === element.department &&
                this.role !== 'teacher'
              ) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              } else if (
                this.role === 'teacher' &&
                this.teacherClassList.includes(element._id)
              ) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = []
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
    getTeachers() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'first_name',
        order: '1',
      }
      this.fetchTeacherList({ filter })
        .then((teachers) => {
          var listitems = []
          teachers.docs.forEach((element) => {
            var ele = {}
            ele.text = element.first_name + ' ' + element.last_name
            ele.value = element._id
            listitems.push(ele)
            this.teacherList = listitems
          })
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <b-modal
    id="meeting-edit-modal"
    title="Update"
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isMeetingSuccess"
          variant="success"
          v-html="meetingSuccess"
        ></b-alert>
        <b-form @submit.prevent="updateMeetingData">
          <b-form-group label="Class Title" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="title"
              type="text"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Class Description" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="description"
              type="text"
              @keypress="restrictChars1($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Class Start Time*" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="startTime"
              type="time"
              placeholder="Enter Time"
              disabled
              style="cursor:not-allowed;background:#e0d9d9;"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Class End Time*" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="endTime"
              type="time"
              placeholder="Enter Time"
              style="cursor:not-allowed;background:#e0d9d9;"
              disabled
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Date*" label-for="input-1">
            <b-form-datepicker
              id="example-datepicker"
              v-model="date"
              :min="getMinDate()"
              disabled
            ></b-form-datepicker>
          </b-form-group>
          <b-form-group
            v-if="role !== 'hod' && role !== 'teacher'"
            label="Department"
            label-for="input-1"
          >
            <b-form-select
              v-model="departmentId"
              :options="departmentlist"
              multiple
              @change="getClasses"
            ></b-form-select>
          </b-form-group>
          <b-form-group label="Class" label-for="input-1">
            <b-form-select
              v-model="collegeClass"
              :options="classlist"
              multiple
            ></b-form-select>
          </b-form-group>
          <p v-if="classEmptyError" style="color:red;"
            >Please select class/department</p
          >
          <!-- <b-form-group
            v-if="role !== 'teacher' && role !== 'hod'"
            label="Select Teacher*"
            label-for="input-1"
          >
            <b-form-select
              v-model="teacherId"
              :options="teacherList"
            ></b-form-select>
          </b-form-group> -->
          <b-alert
            v-model="isMeetingError"
            variant="danger"
            v-html="meetingError"
          ></b-alert>
          <p v-if="timeError" style="color:red;">Added past date/time</p>
          <br />
          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
<style>
.btn .b-icon.bi,
.dropdown-item .b-icon.bi,
.dropdown-toggle .b-icon.bi,
.input-group-text .b-icon.bi,
.nav-link .b-icon.bi {
  color: gray !important;
}

.btn-secondary {
  color: #fff !important;
  background-color: white !important;
  border-color: #ced4da !important;
}

.note {
  font-size: 16px;
  color: black;
  background-color: yellow;
}
</style>
